<script>
  import { login } from '$services/api.js'

  let formElem
  let errorState = false
  let username = '', password = ''

  async function submit () {
    if (username === '' || password === '') {
      errorState = true
    } else {
      errorState = false
    }

    login(username, password).catch(e => {
      console.log(e)
      errorState = true
    })
  }
</script>

<main>
  <div id="login-page">

    <form on:submit|preventDefault={submit} bind:this={formElem} class:error={errorState}>

      <label for="username">Username</label>
      <input type="text" name="username" bind:value={username}>

      <label for="password">Password</label>
      <input type="password" name="password" bind:value={password}>

      <button type="submit">Submit</button>

    </form>

  </div>
</main>

<style lang="scss">
  @import "src/variables.scss";

  main {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 90vh;


    #login-page {
      width: 30vw;
      border: 2px solid $gray7;
      padding: 20px;

      form {
        display: flex;
        flex-direction: column;

        label, button {
          margin-top: 20px;
        }
      }

      .error {
        label {
          color: $error;
        }

        input {
          border: 2px solid $error;
        }
      }
    }
  }
</style>
